import React from 'react';
import {
    EditButton
} from 'react-admin';

const LicenseEditButton = (prop) => {
    return (
        prop.record.isPrimary ? null : <EditButton {...prop} />
    );
}

export default LicenseEditButton;